module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/movie-lane-1-04d399601c21eec470ae2adbb207a8fe.svg";